import { z } from 'zod';

/**
 * One-shot approval token used by WhatsApp / SMS / email deep links.
 * The token itself is never round-tripped through our API in plaintext
 * after issuance — the DB stores only its SHA-256 hash.
 */
export const approvalEntityTypeSchema = z.enum([
  'purchase_request',
  'purchase_order',
  'measurement',
  'change_order',
]);
export type ApprovalEntityType = z.infer<typeof approvalEntityTypeSchema>;

export const approvalActionSchema = z.enum(['approve', 'reject']);
export type ApprovalAction = z.infer<typeof approvalActionSchema>;

export const useApprovalTokenRequestSchema = z.object({
  token: z.string().min(16).max(256),
  reason: z.string().trim().max(500).optional(),
});
export type UseApprovalTokenRequest = z.infer<
  typeof useApprovalTokenRequestSchema
>;

export const issueApprovalTokenRequestSchema = z.object({
  issuedTo: z.string(),
  entityType: approvalEntityTypeSchema,
  entityId: z.string(),
  action: approvalActionSchema,
  ttlSeconds: z.number().int().min(60).max(86_400 * 7).optional(),
});
export type IssueApprovalTokenRequest = z.infer<
  typeof issueApprovalTokenRequestSchema
>;

export const issueApprovalTokenResponseSchema = z.object({
  tokenId: z.string(),
  token: z.string(),
  expiresAt: z.string(),
  url: z.string(),
});
export type IssueApprovalTokenResponse = z.infer<
  typeof issueApprovalTokenResponseSchema
>;
